import { deleteObject, ref } from 'firebase/storage';
import { db, storage } from '../Firebase/firebaseConfig';
import { collection, getDocs, query, orderBy, limit, DocumentSnapshot, startAfter, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { ProductFormData } from '../Forms/schemas/productFormSchema';



export interface ProductItem  extends ProductFormData {
  id: string;
  updatedAt?: string;
  createdAt?: string;
}




export const getProductsFromFirebase = async (
  itemLimit: number,
  lastDoc?: DocumentSnapshot | null
): Promise<{ products: ProductItem[]; lastVisible: DocumentSnapshot | null }> => {
  try {
     
    const productsCollection = collection(db, 'products');

    // Use __name__ for ID-based ordering
    const q = lastDoc
      ? query(productsCollection, orderBy('updatedAt',"desc"), startAfter(lastDoc), limit(itemLimit))
      : query(productsCollection, orderBy('updatedAt',"desc"), limit(itemLimit));

    const querySnapshot = await getDocs(q);
    const Products: ProductItem[] = [];

    querySnapshot.forEach(doc => {
      const data = doc.data();
      Products.push({
        id: doc.id,
        name: data.name || '',
        subtitle: data.subtitle || '',
        productDescription: data.productDescription || '',
        casNumber: data.casNumber || '',
        category: data.category?.toLowerCase() || '',
        base64Image: data.image,
        productDetails: data.productDetails || '',
        createdAt: data.createdAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
        updatedAt: data.updatedAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
        brochure: data.brochure || '',
      });
    });

    const lastVisible = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;

    return { products: Products, lastVisible };
  } catch (error) {
    console.error("Error fetching news from Firebase:", error);
    return { products: [], lastVisible: null };
  }
};

const getStoragePathFromUrl = (url: string): string | null => {
  try {
    const decodedUrl = decodeURIComponent(url.split('?')[0]);
    const pathMatch = decodedUrl.match(/\/o\/(.+)$/);
    return pathMatch ? pathMatch[1] : null;
  } catch {
    return null;
  }
};

export const deleteProductById = async (id: string): Promise<void> => {
   
  try {
    const productsRef = doc(db, 'products', id);
    const productsSnap = await getDoc(productsRef);

    if (!productsSnap.exists()) {
      throw new Error('products not found');
    }

    const productsData = productsSnap.data();

    const urls: string[] = [];

    if (productsData.base64Image) urls.push(productsData.base64Image);
    // if (Array.isArray(productsData.imageBase64s)) urls.push(...productsData.imageBase64s);
    // if (productsData.productsImagesFirst) urls.push(productsData.productsImagesFirst);
    // if (productsData.productsImagesSecond) urls.push(productsData.productsImagesSecond);

    const deletePromises = urls.map((url) => {
      const path = getStoragePathFromUrl(url);
      if (path) {
        const imageRef = ref(storage, path);
        return deleteObject(imageRef).catch((err) => {
          console.warn(`Failed to delete image at ${path}:`, err);
        });
      }
    });

    await Promise.all(deletePromises);
    await deleteDoc(productsRef);
    console.log(`products ${id} and associated images deleted successfully.`);
  } catch (error) {
    console.error("Error deleting products and its images:", error);
    throw new Error("Failed to delete products and its images");
  }
};


export default getProductsFromFirebase;